<template>
    <div class="temp-content-info">
        
        <div class="data-area-name">基础数据</div>
        <div class="content-wrap">
            <!--用户总数-->
            <div class="data-wrap">
                <div class="data-title">用户总数</div>
                <div class="data-value">180</div>
            </div>
        </div>

        <div class="data-area-name">营地数据</div>
            <div class="content-wrap">
                <!--营地数量-->
                <div class="data-wrap">
                    <div class="data-title">营地数量</div>
                    <div class="data-value">180</div>
                </div>
                
                <!--付费营地数量-->
                <div class="data-wrap">
                    <div class="data-title">付费营地</div>
                    <div class="data-value">18</div>
                </div>

                <!--免费营地数量-->
                <div class="data-wrap">
                    <div class="data-title">免费营地</div>
                    <div class="data-value">18</div>
                </div>
            </div>
    </div>
</template>


<script setup>

</script>

<style scoped>
    @import "./index.css";
    @import "../../components/style/style-detail.css";
</style>
  
